import { HeaderAndTableCellDraft } from '@markant-platform/shared/table/model';
import { ChartConfiguration, LinearScaleOptions, ScriptableContext } from 'chart.js';

export const TABLE_HEADER_AND_CELLS: HeaderAndTableCellDraft[] = [
  {
    headerCellColumnId: 'id',
    headerCellTranslationKey: 'usage.report.details.table.headline.date',
    tableCellContentType: 'DATE',
    tableCellDateFormat: 'medium',
    tableCellContentKey: 'id',
  },
  {
    headerCellColumnId: 'totalUsages',
    headerCellTranslationKey: 'usage.report.details.table.headline.servicePackage',
    tableCellContentType: 'NUMBER',
    tableCellContentKey: 'totalUsages',
  },
];

export const USAGE_CHART_X_AXIS: LinearScaleOptions = {
  ticks: {
    color: 'rgba(17,20,22)',
  },
  title: {
    display: true,
    font: {
      weight: 700,
    },
    color: 'rgba(17,20,22)',
  },
  grid: {
    lineWidth: 1,
    color: 'rgba(236, 239, 241)',
  },
  border: {
    display: false,
  },
} as LinearScaleOptions;

export const USAGE_CHART_Y_AXIS: LinearScaleOptions = {
  title: {
    display: true,
    font: {
      weight: 700,
    },
    color: 'rgba(17,20,22)',
  },
  ticks: {
    color: 'rgba(17,20,22)',
  },
  border: {
    display: false,
    dash: [4, 4],
  },
  grid: {
    lineWidth: 1,
    color: 'rgba(236, 239, 241)',
  },
} as LinearScaleOptions;

export const USAGE_CHART: ChartConfiguration<'line'> = {
  type: 'line',
  options: {
    responsive: true,
    maintainAspectRatio: false,
    elements: {
      point: {
        radius: 1,
      },
    },
    scales: {
      x: USAGE_CHART_X_AXIS,
      y: USAGE_CHART_Y_AXIS,
    },
  },
  data: {
    datasets: [
      {
        data: [],
        fill: true,
        xAxisID: 'x',
        yAxisID: 'y',
        tension: 0.1,
        borderColor: strokeColor,
        pointBackgroundColor: strokeColor,
        pointHoverBackgroundColor: strokeColor,
        pointHoverBorderColor: strokeColor,
        backgroundColor: fillColor,
      },
    ],
  },
};

export function strokeColor({ chart }: ScriptableContext<'line'>): CanvasGradient | undefined {
  const { ctx, chartArea } = chart;
  if (!chartArea) {
    return;
  }

  const gradient = ctx.createLinearGradient(chartArea.left, 0, chartArea.right, 0);
  gradient.addColorStop(0, 'rgba(99,150,209,0.5)');
  gradient.addColorStop(0.14, 'rgb(99,150,209)');
  gradient.addColorStop(0.85, 'rgba(99,150,209)');
  gradient.addColorStop(1, 'rgba(99,150,209,0.5)');
  return gradient;
}

export function fillColor({ chart }: ScriptableContext<'line'>): CanvasGradient | undefined {
  const { ctx, chartArea } = chart;
  if (!chartArea) {
    return;
  }

  const gradient = ctx.createLinearGradient(0, chartArea.bottom, 0, chartArea.top);
  gradient.addColorStop(0.5, 'rgba(99,150,209,0.5)');
  gradient.addColorStop(0.2, 'rgba(199, 219, 242, 0.2)');
  gradient.addColorStop(0, 'rgba(199, 219, 242, 0)');
  return gradient;
}
